// this is for navigation URL of routes saved, for example which recording segment folder we are in
// we cannot save it to localStorage because another tab will fight with it and could cause a infinite loop of URL navigation/swap

const locationStore = { recordings: null as string };
export default locationStore;
